import { Grid, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateParticipantPlanning } from '../../../../store/actions/participant/experience';

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        marginTop: 17,
        paddingLeft: 20,
        paddingRight: 20
    },
    header: {
        fontSize: '48px!important',
        fontFamily: 'Spartan-bold',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '0em',
        color: '#212D40',
        textAlign: 'center'
    },
    title: {
        fontFamily: 'roboto-regular',
        fontSize: 18,
        textAlign: 'center'
    },
    img: {
        width: 317,
        height: 204,
        cursor:'pointer',
        '@media (max-width: 1400px)': {
            width: 285,
            height: 166,
        },
    },
    checkTitle: {
        color: '#212D40',
        fontSize: 20,
        textAlign: 'center',
        fontWeight: 'bold'
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 70,
        '@media (max-width: 1400px)': {
            marginTop: 20,
        },
    },
}));

function PlanningStep1() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";

    const onGoNextPage = (value: string) => {
        dispatch(updateParticipantPlanning('userId', loginUserData.user_id));
        dispatch(updateParticipantPlanning('type', value));
        dispatch(updateParticipantPlanning('email', 'support@getimmersion.com'));
        dispatch(updateParticipantPlanning('useremail', loginUserData.username));
        if(value==="I have an experience I want to measure"){
            history.push('/participant/planning/4')
        }
        else{
        history.push('/participant/planning/2')
    }
}

    return (
        <Grid container justifyContent={'center'} className={classes.container}>
            <Grid item lg={7} md={10} sm={12}>
                <p className={classes.header}>
                    Hi! We don&#39;t have any experiences associated with your account.
                </p>

                <p className={classes.title}>
                    Were you planning on participating in an Immersion Experience or creating your own?
                </p>

                <Grid container alignItems='center' justifyContent='center' spacing={1}>
                    <Grid item xs={12} md={6} className={classes.item} >
                        <img
                            className={classes.img}
                            alt="{img}"
                            onClick={() => onGoNextPage('I want to participate in a measurement')}
                            onMouseOver={e => (e.currentTarget.src = "/assets/icons/participant/participant_measurement2.svg")}
                            onMouseOut={e => e.currentTarget.src ="/assets/icons/participant/participant_measurement.svg"}
                            src={"/assets/icons/participant/participant_measurement.svg"}
                        />
                        <p className={classes.checkTitle}>I want to participate in<br /> a measurement</p>
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.item}>
                        <img
                            onClick={() => onGoNextPage('I have an experience I want to measure')}
                            className={classes.img}
                            alt="{img}"
                            onMouseOver={e => (e.currentTarget.src = "/assets/icons/participant/participant_experience2.svg")}
                            onMouseOut={e => e.currentTarget.src ="/assets/icons/participant/participant_experience.svg"}
                            src={"/assets/icons/participant/participant_experience.svg"}
                        />
                        <p className={classes.checkTitle}>I have an experience <br />I want to measure</p>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default PlanningStep1;